import * as tinyCookie from "tiny-cookie"

export default {
  checkLocalStorage() {
    try {
      const test = "__cookie-accept-check-localStorage"
      window.localStorage.setItem(test, test)
      window.localStorage.removeItem(test)
      return true
    } catch (e) {
      console.error(
        "Local storage is not supported, falling back to cookie use"
      )
      return false
    }
  },
  getCookieStatus() {
    if (this.checkLocalStorage()) {
      return localStorage.getItem(
        `cookie-accept`
      )
    } else {
      return tinyCookie.get(`cookie-accept`)
    }
  },
}
